import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "forms",
  name: "forms.name",
  description: "forms.description",
  longDescription: "forms.longDescription",
  category: "shared.categories.ux",
  tags: "forms.tags",
  featured: false,
  status: "coming-soon",
  architecture: "forms.architecture",
  technologies: "forms.technologies",
  concepts: "forms.concepts",
  i18nNamespace: "forms",
};
